import { combineReducers } from "redux";

import userReducer from "./user/reducer";
import loadingReducer from "./loading/reducer";
import alertReducer from "./alert/reducer";
import solicitudReducer from "./solicitud/reducer";


const rootReducer = combineReducers({
  loading: loadingReducer,
  alert: alertReducer,
  solicitud: solicitudReducer,
  user: userReducer,
})

export default rootReducer;
